import { Component, inject, Renderer2 } from '@angular/core';
import { AnalyticsDataPopulateService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AirportDropDown } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { Subject } from 'rxjs';
import { BookingCarsFacadeService } from '../../../data-access/facades/booking-cars/booking-cars-facade.service';

@Component({
  selector: 'idp-booking-cars-base',
  standalone: true,
  templateUrl: './booking-cars-base.component.html',
  styleUrls: []
})
export class BookingCarsBaseComponent {
  render2 = inject(Renderer2);
  bookingCarsFacadeService = inject(BookingCarsFacadeService);
  analyticsService = inject(AnalyticsDataPopulateService);
  isReady = false;
  showAlert = false;
  openModalEvent = false;
  locationModalContent!: AirportDropDown;

  protected destroy$ = new Subject<void>();

  onInitComplete = (success: boolean): void => {
    this.isReady = success;

    if (success) {
      this.removeHeight();
      this.locationModalContent =
        this.bookingCarsFacadeService.adapter.createLocationModalContent([]);
    } else {
      setTimeout(() => {
        this.showAlert = true;
      }, 100);
    }
  };

  addHeight(): void {
    const element = document.querySelector('.header__widgets');
    if (element) {
      this.render2.addClass(element, 'h-[132px]');
      this.render2.addClass(element, 'laptop:h-[122px]');
    }
  }

  removeHeight(): void {
    const element = document.querySelector('.header__widgets');
    if (element) {
      this.render2.removeClass(element, 'h-[132px]');
      this.render2.removeClass(element, 'laptop:h-[122px]');
    }
  }

  cleanup(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
